import React from "react";
import PropTypes from "prop-types";
import LoadingButton from "@mui/lab/LoadingButton";

//#region internal button styles
const LoadingButtonStyled = ({
  sx,
  children,
  variant = "primary",
  size = "medium",
  type = "submit",
  onClick = null,
  fullWidth = false,
  disabled = false,
  loading = false,
  maxWidth = null,
}) => {
  return (
    <LoadingButton
      variant={variant}
      size={size}
      type={type}
      onClick={onClick}
      sx={{
        ...sx,
        ...(maxWidth && {
          maxWidth,
          width: "100%",
        }),
        height: sx && sx.height ? sx.height : "100%",
      }}
      fullWidth={fullWidth}
      disabled={disabled}
      loading={loading}
    >
      {children}
    </LoadingButton>
  );
};

LoadingButtonStyled.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "contained",
    "outlined",
    "text",
    "text-alt",
    "unhovered",
    "hovered",
    "ey-default",
    "white",
  ]),
  type: PropTypes.oneOf(["submit", "reset", "button"]),
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullWidth: PropTypes.bool,
  fullHeight: PropTypes.bool,
  sx: PropTypes.object,
  loading: PropTypes.bool,
};
//#endregion

export default LoadingButtonStyled;
